import { render, staticRenderFns } from "./VendorAdmin.vue?vue&type=template&id=8c409a80&"
import script from "./VendorAdmin.vue?vue&type=script&lang=js&"
export * from "./VendorAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports